import React from "react";
import OrderItem from "../components/OrderItem";

const AddItemModal = ({
  menuItem,
  category,
  relation,
  currentOrderItem,
  selectedItemSupplements,
  itemInstructions,
  t,
  menuItemTypes,
  onlyAdditions = false,
  closeModal,
  onOk,
  onDelete,
  currentLanguageId,
  branchInfo,
}) => {
  return (
    <OrderItem
      menuItem={menuItem}
      category={category}
      relation={relation}
      currentOrderItem={currentOrderItem}
      selectedItemSupplements={selectedItemSupplements}
      itemInstructions={itemInstructions}
      t={t}
      onlyAdditions={onlyAdditions}
      menuItemTypes={menuItemTypes}
      addToCart={onOk}
      close={closeModal}
      deleteFromCart={onDelete}
      showCloseButton
      currentLanguageId={currentLanguageId}
      branchInfo={branchInfo}
    />
  );
};

export default AddItemModal;
